<template>
	<v-app-bar v-if="showFullNavbar" app :extended="isAuthenticated" color="primary" dark extension-height="70px">
		<NavIcon /> <NavTitle />

		<!-- IF LOGGED IN -->
		<template v-if="isAuthenticated">
			<PageSwitcher class="ml-3" v-if="showPublicSwitcher" v-model="isAdminMode" />
			<v-spacer />

			<InternalLinks />
			<v-spacer />

			<!-- Extra navbar row when authenticated -->
			<template slot="extension" v-if="isAuthenticated">
				<NavTabs v-if="showTabs" :routes="routes" :isAdminMode="isAdminMode" />
				<InfoChip outlined icon="mdi-account" :text="username" />
			</template>

			<amplify-sign-out @click="signOut" v-show="isAuthenticated" />
		</template>

		<!-- IF NOT LOGGED IN -->
		<template v-else>
			<NavTabs v-if="showTabs" :routes="routes" :isAdminMode="isAdminMode" />
			<v-spacer />
			<LoginButton v-show="!isAuthenticated" @click="$emit('show-auth')" />
		</template>
	</v-app-bar>

	<!-- Shown on mobile, replaces navbar -->
	<div v-else >
		<InternalLinks />
		<LoginButton v-show="!isAuthenticated" @click="$emit('show-auth')" />
		<NavList class="mobile-nav-list" :routes="routes" />
	</div>
	
</template>

<script>
import publicRoutes from '@/router/routes'
import adminRoutes from '@/router/admin-routes'

import NavIcon from '@/components/AppNavIcon'
import NavTitle from '@/components/AppNavTitle'
import NavTabs from '@/components/base/AppNavTabs'

import NavList from '@/components/base/AppNavList'
import InfoChip from '@/components/InfoChip'

import LoginButton from '@/components/ui/LoginButton'

import { mapGetters } from 'vuex'

export default {
	name: 'AppNavigation',

	components: {
		NavIcon,
		NavTitle,
		NavTabs,
		NavList,
		InfoChip,
		LoginButton,
		PageSwitcher: () => import('@/components/admin/PageSwitcher'),
		InternalLinks: () => import('@/components/admin/AppNavInternal')
	},

	data() {
		return {
			isAdminMode: null,
			showTabs: true
		}
	},

	watch: {
		// If admin authenticates, set isAdminMode initially to true
		isAdmin(value) {
			if (value) this.isAdminMode = true
		},

		// Change path and navtabs if switching between public/admin mode
		async isAdminMode(isAdmin, oldValue) {
			if (oldValue == null || isAdmin == oldValue) return
			const { path } = this.$router.currentRoute

			// append or remove /admin/ from path, to toggle between public and internal pages
			const newPath = isAdmin ? `/admin${path}` : path.replace('/admin', '')

			// Hack refresh nav tabs
			this.showTabs = false
			await this.$nextTick()
			this.showTabs = true

			this.$router.push(newPath)
		}
	},

	computed: {
		...mapGetters(['isAdmin', 'isAuthenticated', 'username', 'userRoles']),

		routes() {
			return this.isAdminMode
				? adminRoutes.filter(({ meta }) => !meta.hideInNavbar)
				: publicRoutes.filter(({ meta }) => !meta.hideInNavbar && !meta.requiresAuth)
		},

		// Switcher to toggle between editing and showing public pages
		showPublicSwitcher() {
			if(!this.isAdmin) return false
			return !this.$router.currentRoute.meta.noPublicSwitcher
		},

		// Set navbar type based on viewport width
		showFullNavbar() {
			const { name } = this.$vuetify.breakpoint
			return name != 'xs' && name != 'sm'
		}
	},

	methods: {
		signOut() {
			this.$store.dispatch('signOut')
			this.isAdminMode = false
			this.$router.push('/')
		}
	}
}
</script>